/*
  components/App
*/

import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  withRouter,
  Link,
  Switch,
  Redirect,
} from 'react-router-dom'
import Icon from 'react-icons-kit'
import Helmet from 'react-helmet'
import { calendar_add as ikonsCalendar_add } from 'react-icons-kit/ikons/calendar_add'
import { heartbeat as faHeartbeat } from 'react-icons-kit/fa/heartbeat'
import { stethoscope as faStethoscope } from 'react-icons-kit/fa/stethoscope'
import { child as faChild } from 'react-icons-kit/fa/child'
import { cubes as faCubes } from 'react-icons-kit/fa/cubes'
import { dropbox as faDropbox } from 'react-icons-kit/fa/dropbox'
import { plusCircle as faPlusCircle } from 'react-icons-kit/fa/plusCircle'
import { newspaper as icomoonNewspaper } from 'react-icons-kit/icomoon/newspaper'
import { ic_accessibility as mdAccessbility } from 'react-icons-kit/md/ic_accessibility'
import { home as entypoHome } from 'react-icons-kit/entypo/home'
import { iosPeople as ioniconsIosPeople } from 'react-icons-kit/ionicons/iosPeople'
import { Drawer, MenuItem, Divider, FloatingActionButton, RaisedButton, IconMenu } from 'material-ui'
import { List, ListItem } from 'material-ui/List'
import BreakPoint from '../../responsive-utilities/breakpoint'
import Header from '../Header'
import Footer from '../Footer'
import Home from '../Home'
import Services from '../Services'
import Treatments from '../Treatments'
import Conditions from '../Conditions'
import Products from '../Products'
import Tests from '../Tests'
import About from '../About'
import Appointment from '../Appointment'
import Biography from '../Biography'
import Contact from '../Contact'
import NewsMedia from '../NewsMedia'
import data from '../../data'
import './style.css'
import logoDrawer from '../../assets/img/logo-drawer.png'

const styles = {
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    color: '#777',
  },
  menuItemIcon: {
    paddingRight: '1rem',
  },
}

const menuItems = [{
  label: 'Home',
  icon: (props) => {
    return <Icon icon={entypoHome} {...props} />
  },
  props: {
    to: '/',
  },
}, {
  label: 'About',
  icon: (props) => {
    return <Icon icon={ioniconsIosPeople} {...props} />
  },
  props: {
    to: '/about',
  },
}, {
  label: 'Dermatology',
  icon: (props) => {
    return <Icon icon={faHeartbeat} {...props} />
  },
  props: {
    to: '/dermatology',
  },
  items: Object.keys(data.conditions.dermatology.child).map((key) => {
    return {
      label: data.conditions.dermatology.child[key].name,
      props: {
        to: `/conditions/dermatology/${key}`,
      },
    }
  }).sort((a, b) => {
    return a.label > b.label
  }),
}, {
  label: 'Aesthetics',
  icon: (props) => {
    return <Icon icon={mdAccessbility} {...props} />
  },
  props: {
    to: '/aesthetics',
  },
  items: Object.keys(data.conditions.aesthetics.child).map((key) => {
    return {
      label: data.conditions.aesthetics.child[key].name,
      props: {
        to: `/conditions/aesthetics/${key}`,
      },
    }
  }).sort((a, b) => {
    return a.label > b.label
  }),
}, {
  label: 'Treatment',
  icon: (props) => {
    return <Icon icon={faPlusCircle} {...props} />
  },
  props: {
    to: '/treatments',
  },
  items: Object.keys(data.treatments).map((key) => {
    return {
      label: data.treatments[key].name,
      props: {
        to: `/treatments/${key}`,
      },
    }
  }).sort((a, b) => {
    return a.label > b.label
  }),
},
/*
{
  label: 'Services',
  icon: (props) => {
    return <Icon icon={faHeartbeat} {...props} />
  },
  props: {
    to: '/services',
  },
  items: [{
    'treatment': {
      label: 'Treatment',
      child: Object.keys(data.treatments).map((key) => {
        // console.log(data.treatments[key].name)
        return {
          label: data.treatments[key].name,
          props: {
            to: `/treatments/${key}`,
          },
        }
      })
    },
    'conditions': {
      label: 'Conditions',
      child: Object.keys(data.conditions).map((key) => {
        return {
          label: data.conditions[key].name,
          props: {
            to: `/conditions/${key}`,
          },
          smallChild : Object.keys(data.conditions[key].child).map((smallKey) => {
            return{
              label: data.conditions[key].child[smallKey].name,
              props: {
                to: `/conditions/${key}/${smallKey}`,
              },
            }
          })
        }
      })
    },
  }],
},
*/
{
  label: 'Products',
  icon: (props) => {
    return <Icon icon={faDropbox} {...props} />
  },
  props: {
    to: '/products',
  },
  items: Object.keys(data.products).map((key) => {
    return {
      label: data.products[key].name,
      props: {
        to: `/products/${key}`,
      },
    }
  }).sort((a, b) => {
    return a.label > b.label
  }),
},
{
  label: 'Tests',
  icon: (props) => {
    return <Icon icon={faStethoscope} {...props} />
  },
  props: {
    to: '/tests',
  },
  items: Object.keys(data.tests).map((key) => {
    return {
      label: data.tests[key].name,
      props: {
        to: `/tests/${key}`,
      },
    }
  }).sort((a, b) => {
    return a.label > b.label
  }),
}, {
  label: 'News & Media',
  icon: (props) => <Icon icon={icomoonNewspaper} {...props} />,
  props: {
    to: '/news-media',
  },
}, {
  label: 'Contact',
  icon: (props) => {
    return <Icon icon={faChild} {...props} />
  },
  props: {
    to: '/contact',
  },
}]

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    return this.props.children
  }
}

ScrollToTop = withRouter(ScrollToTop)

class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      drawerOpen: false,
      font: 'Proxima Nova',
    }

    this.handleScroll = this.handleScroll.bind(this)
    this.toggleDrawer = this.toggleDrawer.bind(this)
    this.closeDrawer = this.closeDrawer.bind(this)
    this.changeFont = this.changeFont.bind(this)

    this.currentScrollTop = 0
    this.hideExtraThreshold = 32
    this.hideExtra = false

    this.fonts = {
      'Roboto': 'font-roboto',
      'Proxima Nova': 'font-proxima-nova',
      'Josefin Sans': 'font-josefin-sans',
      'Spectral': 'font-spectral',
      'Raleway': 'font-raleway',
      'Dosis': 'font-dosis',
      'Slabo 27px': 'font-slabo',
      'Lato': 'font-lato',
      'Open Sans': 'font-open-sans',
      'Bubbler One': 'font-bubbler-one',
      'Montserrat': 'font-montserrat',
      'Source Sans Pro': 'font-source-sans-pro',
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll(event) {
    if (event.srcElement.body.scrollTop > this.currentScrollTop
      && !this.hideExtra
      && event.srcElement.body.scrollTop > this.hideExtraThreshold
    ) {
      this.hideExtra = true
      const refApp = ReactDOM.findDOMNode(this.refs.App)
      refApp && refApp.classList.add('topbar-hide')
    }

    if (event.srcElement.body.scrollTop < this.currentScrollTop
      && this.hideExtra
    ) {
      this.hideExtra = false
      const refApp = ReactDOM.findDOMNode(this.refs.App)
      refApp && refApp.classList.remove('topbar-hide')
    }
    this.currentScrollTop = event.srcElement.body.scrollTop
  }

  toggleDrawer() {
    this.setState({ drawerOpen: !this.state.drawerOpen })
  }

  openDrawer = () => {
    this.setState({ drawerOpen: true })
  }

  closeDrawer() {
    this.setState({ drawerOpen: false })
  }

  changeFont(event, value) {
    this.setState({ font: value })
  }

  render() {
    const actions = {
      toggleDrawer: this.toggleDrawer,
      openDrawer: this.openDrawer,
    }

    const classNames = {
      App: `App ${this.fonts[this.state.font]}`,
    }

    return (
      <Router>
        <ScrollToTop>
          <div className={classNames.App} ref="App">
            <Helmet>
              <title>{`${data.name} - Damansara PJ`}</title>
              <meta name="description" content={data.description} />
              <script src="https://challenges.cloudflare.com/turnstile/v0/api.js" async defer></script>
              <link rel="preconnect" href="https://challenges.cloudflare.com" />
            </Helmet>
            <Header menuItems={menuItems} actions={actions} data={data} />
            <BreakPoint query="xs">
              {(matches) => {
                if (matches) {
                  return <div style={{ height: '7rem' }}></div>
                } else {
                  return <div style={{ height: '8rem' }}></div>
                }
              }}
            </BreakPoint>

            <div className="section">
              <div className="section-bg"></div>
              <div className="section-bg"></div>
            </div>

            <div className="content">
              {/*bg - code */}
              <Switch>
                <Route exact path="/" render={(props) => <Home {...props} data={data} />} />
                <Route path="/about" render={(props) => <About {...props} data={data} />} />
                <Route exact path="/services" render={(props) => <Services {...props} data={data} />} />
                <Route exact path="/treatments" render={(props) => <Treatments {...props} data={data} />} />
                <Route path="/treatments/:treatmentId" render={(props) => <Treatments {...props} data={data} />} />
                <Route exact path="/conditions" render={(props) => <Conditions {...props} data={data} />} />
                <Route exact path="/conditions/:conditionId" render={(props) => <Conditions {...props} data={data} />} />
                <Route path="/conditions/:conditionId/:conditionChildId" render={(props) => <Conditions {...props} data={data} />} />
                <Route path="/appointment" render={(props) => <Appointment {...props} data={data} />} />
                <Route exact path="/products" render={(props) => <Products {...props} data={data} />} />
                <Route path="/products/:productId" render={(props) => <Products {...props} data={data} />} />
                <Route exact path="/tests" render={(props) => <Tests {...props} data={data} />} />
                <Route path="/tests/:testId" render={(props) => <Tests {...props} data={data} />} />
                <Route exact path="/biography" render={(props) => <Biography {...props} data={data} />} />
                <Route path="/biography/:doctorId" render={(props) => <Biography {...props} data={data} />} />
                <Route path="/contact" render={(props) => <Contact {...props} data={data} />} />
                <Route path="/news-media" render={(props) => <NewsMedia {...props} data={data} />} />
                <Route render={(props) => <Home {...props} data={data} />} />
              </Switch>
            </div>

            <Footer data={data} />

            <BreakPoint query="smDown">
              {(matches) => {
                if (matches) {
                  return (
                    <Link to="/appointment" className="floating-button-appointment" ref="floatingButtonAppointment">
                      <FloatingActionButton>
                        <Icon icon={ikonsCalendar_add} size={24} />
                      </FloatingActionButton>
                    </Link>
                  )
                } else {
                  return (
                    <div className="container text-right">
                      <Link to="/appointment">
                        <RaisedButton
                          primary={true}
                          className="floating-button-appointment big"
                          label="Book Appointment"
                        />
                      </Link>
                    </div>
                  )
                }
              }}
            </BreakPoint>

            <Drawer
              docked={false}
              open={this.state.drawerOpen}
              onRequestChange={(drawerOpen) => this.setState({ drawerOpen })}
              className="drawer"
              width={320}
              containerStyle={{
                maxWidth: 'calc(100vw - 3rem)',
              }}
            >
              <img src={logoDrawer} className="drawer-logo" alt={data.name} />
              <Divider />
              <List>
                {menuItems.map((item, key) => {
                  const props = {
                    ...item.props,
                    className: 'item',
                  }

                  return (
                    <ListItem
                      containerElement={!item.items && <Link {...props} /> || <div />}
                      primaryText={item.label}
                      leftIcon={item.icon && item.icon()}
                      primaryTogglesNestedList={true}
                      onClick={(e) => {
                        !item.items && this.closeDrawer(e)
                      }}
                      nestedItems={item.items && item.items.length && item.items.map((subItem, subKey) => (
                        <ListItem
                          primaryText={subItem.label}
                          containerElement={<Link {...subItem.props} />}
                          onClick={(e) => {
                            !subItem.items && this.closeDrawer(e)
                          }}
                          insetChildren={true}
                          innerDivStyle={{
                            marginLeft: 0,
                          }}
                          key={subKey}
                        />
                      )).concat(<Divider key="divider2" />)}
                      key={key}
                    />
                  )
                })}
              </List>
            </Drawer>

            {false &&
              <div className="floating-font-picker">
                <IconMenu
                  iconButtonElement={<RaisedButton label={`Font: ${this.state.font}`} />}
                  value={this.state.font}
                  onChange={this.changeFont}
                >
                  {
                    Object.keys(this.fonts).map((fontName, key) => {
                      return (
                        <MenuItem value={fontName} primaryText={fontName} key={key} />
                      )
                    })
                  }
                </IconMenu>
              </div>
            }
          </div>
        </ScrollToTop>
      </Router>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/components/App/index.js